var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tile tile-project",
      on: {
        mouseleave: function ($event) {
          return _vm.onToggleMenu(false)
        },
      },
    },
    [
      _c("router-link", { attrs: { to: _vm.info.url } }, [
        _c("header", [
          _vm._v(_vm._s(_vm.info.title) + " "),
          _c("span", {
            attrs: { title: "More" },
            on: {
              mouseenter: function ($event) {
                return _vm.onToggleMenu(true)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "p",
          [
            _vm.info.programs
              ? [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.getActiveListLength(
                          _vm.info.programs,
                          _vm.info.isArchived
                        ) === 1
                          ? "1 program"
                          : _vm.getActiveListLength(
                              _vm.info.programs,
                              _vm.info.isArchived
                            ) + " programs"
                      ) +
                      "\n            "
                  ),
                ]
              : _vm.info.studies
              ? [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.getActiveListLength(
                          _vm.info.studies,
                          _vm.info.isArchived
                        ) === 1
                          ? "1 study"
                          : _vm.getActiveListLength(
                              _vm.info.studies,
                              _vm.info.isArchived
                            ) + " studies"
                      ) +
                      "\n            "
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.info.processStatus
              ? [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.getProcessStatus(_vm.info)) +
                      "\n            "
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "small",
              {
                attrs: {
                  title: _vm.$moment
                    .utc(_vm.info.updateDate)
                    .format("DD/MM/YYYY"),
                },
              },
              [
                _vm._v(
                  "Modified: " +
                    _vm._s(_vm.$moment.utc(_vm.info.updateDate).from())
                ),
              ]
            ),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "title-menu",
          class: { open: _vm.isMenuOpen },
          on: {
            click: function ($event) {
              return _vm.onToggleMenu(false)
            },
          },
        },
        [
          _c(
            "ul",
            [
              !_vm.info.isArchived
                ? [
                    _c("li", { on: { click: _vm.onRenameClick } }, [
                      _vm._v("Rename"),
                    ]),
                    _vm._v(" "),
                    _c("li", { on: { click: _vm.onCloneClick } }, [
                      _vm._v("Clone"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.onArchiveClick(true)
                          },
                        },
                      },
                      [_vm._v("Archive")]
                    ),
                  ]
                : [
                    _c(
                      "li",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.onArchiveClick(false)
                          },
                        },
                      },
                      [_vm._v("Unarchive")]
                    ),
                  ],
              _vm._v(" "),
              _vm.allowDelete()
                ? [
                    _c(
                      "li",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.onDeleteClick(false)
                          },
                        },
                      },
                      [_vm._v("Delete")]
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.allowImportStudy()
                ? [
                    _c("li", { on: { click: _vm.onImportStudyClick } }, [
                      _vm._v("Import a study"),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c("Modal", { ref: "modalSetSeed", attrs: { title: "Set seed value" } }, [
        _c("form", { on: { submit: _vm.onSetSeedSubmit } }, [
          _c("div", { staticClass: "input", attrs: { type: "text" } }, [
            _c("label", [
              _c("span", [_vm._v("Seed value")]),
              _vm._v(" "),
              _c("input", {
                ref: "setSeedInput",
                attrs: { type: "text", placeholder: "New seed value" },
                domProps: { value: _vm.info.seed },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "right edit", class: { loading: _vm.isLoading } },
            [_vm._v("Set seed")]
          ),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "left edit",
            on: {
              click: function ($event) {
                return _vm.onSuggestSeedClick()
              },
            },
          },
          [_vm._v("Suggest seed")]
        ),
        _vm._v(" "),
        _vm.suggestedSeed != ""
          ? _c(
              "button",
              {
                staticClass: "left edit",
                on: {
                  click: function ($event) {
                    return _vm.onSuggestSeedInsertClick()
                  },
                },
              },
              [_vm._v("Insert seed: " + _vm._s(_vm.suggestedSeed))]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("Modal", { ref: "modalRename", attrs: { title: "Rename" } }, [
        _c("form", { on: { submit: _vm.onRenameSubmit } }, [
          _c("div", { staticClass: "input", attrs: { type: "text" } }, [
            _c("label", [
              _c("span", [_vm._v("Name")]),
              _vm._v(" "),
              _c("input", {
                ref: "renameNameInput",
                attrs: { type: "text", placeholder: "New name" },
                domProps: { value: _vm.info.title },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "right edit", class: { loading: _vm.isLoading } },
            [_vm._v("Rename")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "Modal",
        { ref: "modalImportStudy", attrs: { title: "ImportStudy" } },
        [
          _c("form", { on: { submit: _vm.onImportStudySubmit } }, [
            _c("div", { staticClass: "input", attrs: { type: "text" } }, [
              _c("label", [
                _c("span", [_vm._v("Study title")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.importStudyTitle,
                      expression: "importStudyTitle",
                    },
                  ],
                  ref: "importStudyTitle",
                  attrs: { type: "text", placeholder: "Study title" },
                  domProps: { value: _vm.importStudyTitle },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.importStudyTitle = $event.target.value
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input", attrs: { type: "textarea" } }, [
              _c("label", [
                _vm._v(
                  "\n                    Copy paste study json you want to import. Keys will automatically be corrected.\n                    "
                ),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.importStudyInput,
                      expression: "importStudyInput",
                    },
                  ],
                  ref: "importStudyInput",
                  domProps: { value: _vm.importStudyInput },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.importStudyInput = $event.target.value
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "right edit", class: { loading: _vm.isLoading } },
              [_vm._v("Import now")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }